module.exports = __webpack_public_path__ + "static/media/promociones_mepal.35dc8140.svg";